document.addEventListener("DOMContentLoaded", function(event) {
  const buttons = document.querySelectorAll("[data-toggle='modal']");

  if (buttons.length === 0) {
    return;
  }

  buttons.forEach(button => {
    button.addEventListener("click", function() {
      const modalId = button.getAttribute("data-target");
      const modal = document.querySelector(modalId);

      if (modal) {
        modal.classList.add("catalog-modal--show");

        const dismissButton = modal.querySelector("[data-dismiss='modal']");

        if (dismissButton) {
          dismissButton.addEventListener("click", function() {
            modal.classList.remove("catalog-modal--show");
          });
        }
      }
    });
  });
});
